import { createSlice } from '@reduxjs/toolkit'
import { GetUrlMapAsync, GetUrlMapAsyncBuilder } from './asyncRequests'
import { CreateUrlMapAsync, CreateUrlMapAsyncBuilder } from './asyncRequests/createUrlMapAsync'

export interface UrlMapDocument {
  code: string
  shortUrl: string
  originalUrl: string
}

export interface IUrlMapState {
  loading: boolean
  data?: UrlMapDocument,
  error: boolean
}

export const UrlMapState: IUrlMapState = {
  loading: false,
  error: false,
  data: undefined,
}

const UrlMapSlice = createSlice({
  name: 'urlMaps',
  initialState: UrlMapState,
  reducers: {},
  extraReducers: (builder) => {
    GetUrlMapAsyncBuilder(builder)
    CreateUrlMapAsyncBuilder(builder)
  },
})

export const UrlMapActions = {
  ...UrlMapSlice.actions,
  GetUrlMapAsync,
  CreateUrlMapAsync,
}

export const UrlMapReducer = UrlMapSlice.reducer
